import { Building2, Users, MapPin, ShieldCheck } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

function useListingCount() {
  return useQuery({
    queryKey: ["listing-count"],
    queryFn: async () => {
      const { count, error } = await supabase
        .from("listings")
        .select("*", { count: "exact", head: true })
        .eq("status", "active");
      if (error) throw error;
      return count ?? 0;
    },
    staleTime: 60_000,
  });
}

export default function StatsSection() {
  const { data: listingCount } = useListingCount();
  const displayCount = listingCount != null ? listingCount.toLocaleString() : "—";

  const stats = [
    {
      icon: Building2,
      value: displayCount,
      label: "Listed Med Spas",
    },
    {
      icon: Users,
      value: "2M+",
      label: "Lifetime Visitors",
    },
    {
      icon: MapPin,
      value: "50",
      label: "States Covered",
    },
    {
      icon: ShieldCheck,
      value: "100%",
      label: "Verified Providers",
    },
  ];

  return (
    <section className="relative z-10 -mt-12 lg:-mt-16 pb-4">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="card-premium grid grid-cols-2 lg:grid-cols-4 overflow-hidden divide-x divide-y lg:divide-y-0 divide-white/10">
          {stats.map((stat) => (
            <div key={stat.label} className="p-6 lg:p-8">
              <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-primary/10 border border-primary/20 text-primary mb-4">
                <stat.icon className="w-5 h-5" />
              </div>
              <div className="text-3xl lg:text-4xl font-extrabold tracking-tight text-foreground mb-1">
                {stat.value}
              </div>
              <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
